/*******************************************************************************
 * @ngdoc    object
 * @module   makeDeposit
 * @name     csm.books.MakeDeposit.Data.type:DepositReceiptSalesItem
 * @constructor
 * @param {object=} item  Item info read from database.
 * @description
 * Sales totals by account for a receipt.
 *******************************************************************************/
/* @ngInject */ export function runDepositReceiptSalesItemData(Data) {
  Data.DepositReceiptSalesItem = function (item) {
    return Object.assign(
      Object.create(Data.DepositReceiptSalesItem.prototype),
      item || {}
    );
  };

  Data.DepositReceiptSalesItem.prototype = {
    description: null, // Description
    accountID: NaN, // Account ID.
    accountNumber: null, // Account Number
    accountName: null, // Account Name
    amount: NaN // Item/Account Total Amount
  };

  Object.defineProperties(Data.DepositReceiptSalesItem.prototype, {
    /**
     * @ngdoc       property
     * @name        accountInfo
     * @propertyOf  csm.books.MakeDeposit.Data.type:DepositReceiptSalesItem
     * @description Account info used by `accountSelector`.
     */
    accountInfo: {
      get: function () {
        return {
          accountID: this.accountID,
          accountName: this.accountName,
          accountNumber: this.accountNumber
        }
      }
    }
  });
};
